import Keycloak from 'keycloak-js'

const keyclockAuthUrl: string | undefined = process.env.KEYCLOCK_AUTH_URL ? process.env.KEYCLOCK_AUTH_URL : "";
const keyclockRealm: string | undefined = process.env.KEYCLOCK_REALM ? process.env.KEYCLOCK_REALM : "";
const keyclockReactClientId: string | undefined = process.env.KEYCLOCK_REACT_CLIENT_ID ? process.env.KEYCLOCK_REACT_CLIENT_ID : "";
const keyclockAdminGroup: string | undefined = process.env.KEYCLOCK_ADMIN_GROUP ? process.env.KEYCLOCK_ADMIN_GROUP : "COMMON_ADMIN_GROUP";
const keyclockAdminCheckerGroup: string | undefined = process.env.KEYCLOCK_ADMIN_CHECKER_GROUP ? process.env.KEYCLOCK_ADMIN_CHECKER_GROUP : "ADMIN_CHECKER_GROUP";
const keyclockAdminAuthorizerGroup: string | undefined = process.env.KEYCLOCK_ADMIN_AUTHORIZER_GROUP ? process.env.KEYCLOCK_ADMIN_AUTHORIZER_GROUP : "ADMIN_AUTHORIZER_GROUP";
const keyclockManagerGroup: string | undefined = process.env.KEYCLOCK_MANAGER_GROUP ? process.env.KEYCLOCK_MANAGER_GROUP : "MANAGER_GROUP";
const keyclockRelationshipManagerGroup: string | undefined = process.env.KEYCLOCK_RM_GROUP ? process.env.KEYCLOCK_RM_GROUP : "RM_GROUP";


const keycloakConfig = {
    url: keyclockAuthUrl,
    realm: keyclockRealm,
    clientId: keyclockReactClientId
}
const keycloak =new Keycloak(keycloakConfig);
export const keycloakProviderInitConfig = {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
}

export const onKeycloakEvent = (event: any, error: any) => {
    console.log('onKeycloakEvent', event, error)
}

export const onKeycloakTokens = (tokens: any) => {
    console.log('onKeycloakTokens', tokens)
}

export const onUpdateToken = (successCallback: any): any => {
    return keycloak.updateToken(5)
        .then(successCallback)
        .catch(keycloak.login);
}

export const hasRole = (roles:any) => roles.some((role:any) => keycloak.hasRealmRole(role));

export const isLoggedIn = () => !!keycloak.token;

export const getUserInfo = () => keycloak.loadUserInfo();

export const isAdminUser = () => {
    return keycloak.tokenParsed?.GROUP_LIST.includes(keyclockAdminGroup)
};

export const isAdminCheckerUser = () => {
    return keycloak.tokenParsed?.GROUP_LIST.includes(keyclockAdminCheckerGroup)
};
export const isAdminAuthorizerUser = () => {
    return keycloak.tokenParsed?.GROUP_LIST.includes(keyclockAdminAuthorizerGroup)
};

export const getLoggedUserId = () => {
    return keycloak.tokenParsed?.sub
};

export const getLoggedUserCinNumber = () => {
    return undefined != keycloak.tokenParsed?.CIN ? keycloak.tokenParsed?.CIN : keycloak.tokenParsed?.cin
};
export const getManagerCode = () => keycloak.tokenParsed?.manager_code;
export const getRmCode = () => keycloak.tokenParsed?.rm_code;
export const getTokenPrased = () => keycloak.tokenParsed;

export const isManagerUser = () => {
    return keycloak.tokenParsed?.GROUP_LIST.includes(keyclockManagerGroup)
};

export const isRelationshipManagerUser = () => {
    return keycloak.tokenParsed?.GROUP_LIST.includes(keyclockRelationshipManagerGroup)
};

export const isCustomer = () => {
    let adminTypes = [keyclockAdminGroup, keyclockManagerGroup, keyclockRelationshipManagerGroup]
    return !adminTypes.some(value => keycloak.tokenParsed?.GROUP_LIST.includes(value));

};



export default keycloak
